import { CPRS_STATE_APPLICATION_QUERY } from "@/graphql/cprs-state-to-state-application-query";
import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import {
  CprsStateApplication,
  FormFieldContents,
  FormNavbar,
} from "@/models/cprs-state-to-state-application/cprs-state-to-state-application.interface";
import StateToStatePreviewFormComponent from "../cprs-state-to-state-preview-form/cprs-state-to-state-preview.component.vue";
import { utils } from "@/utils/utils";
import moment from "moment";
import DropdownListComponent from "../dropdown-list/dropdown-list.component.vue";
import { loginApi } from "@/providers/apis/login";
import { stateToStateFormApi } from "@/providers/apis/state-to-state-form";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import EligibilityPopupComponent from "../eligibility-qsn-valid-popup/eligibility-qsn-valid-popup.vue";

@Component({
  name: "cprs-state-to-state-application",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-state-to-state-preview-form": StateToStatePreviewFormComponent,
    "b-form-dropdown": DropdownListComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
    EligibilityPopupComponent,
  },
})
export default class CprsStateToStateApplicationComponent extends Vue {
  public isScroll = false;
  public stateApplicationData: Array<CprsStateApplication> = [];
  public applicationNavData: FormNavbar[] = [];
  public formData: FormFieldContents[] = [];
  public formPagination = 0;
  public isValid = false;
  public isNavLoad = false;
  public saveDataDraft = false;
  public currentForm: any;
  public formName = "stateToStateBasicDetails";
  public formTitle = {
    main_title: "",
    sub_title: "",
  };
  public stateToStatepayLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    stateToStateBasicDetails: {
      firstName: "",
      lastName: "",
      otherFirstName: "",
      otherLastName: "",
      gender: "",
      dob: "",
      socialSecurityNumber: "",
      veteranStatus: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: "",
      workEmail: null,
    },
    stateToStateCertificationDetails: {
      currentlyCertifiedOtherThanTennessee: "",
      currentState: "",
      certificateFiles: "",
      contactPersonFirstName: "",
      contactPersonLastName: "",
      contactPersonPhone: "",
      contactPersonEmail: "",
      selfDirectedRecovery: "",
      disclosedToPeers: "",
      highSchool: [],
      highSchoolNotListed: "",
    },
    stateToStateSignatureSubmission: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
    },
  };
  public hideDiv: string[] = ["highSchoolNotListed"];
  public checkField: string[] = ["highSchool"];
  public signatureInvalid = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public isEdit = false;
  public checkValidForm = false;
  public formCompletedIndex: number[] = [];
  public mainId = "app";
  public currentRoute = "";
  public isFileValid = false;
  public isErrDobAge = false;
  public eligibilityPopup = false;
  public eligibilityPopupMsg = "";
  public isLoading = true;
  public formApplicationId = "";
  public currentDMY = "";
  public notFilesUploadedKeyNames: string[] = [];
  public errorMessage = "";

  public async created() {
    this.currentRoute = this.$route.path;
    const currentMonth = `${moment().month() + 1}`;
    this.currentDMY = `${moment().year()}-${
      currentMonth.length == 1 ? "0" : ""
    }${currentMonth}-${moment().date()}`;

    loginApi
      .logInWithCredential(
        appConfigService.getClientId(),
        appConfigService.getClientKey(),
        "anonymous"
      )
      .then((data) => {
        this.isLoading = false;
        localStorage.setItem("anonymousToken", data.access_token);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
    let payloadStorage: any = localStorage.getItem("stateToStatepayLoadData");
    const formFilledIndex: any = localStorage.getItem(
      "stateToStateFilledIndex"
    );
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    }
    // Re-derive step 0 completion from a live validation so a stale mark can't
    // make the finalize gate skip an unfinished Basic Details tab.
    this.syncStepZeroOnLoad();
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.stateToStatepayLoadData = {
        ...this.stateToStatepayLoadData,
        ...payloadStorage,
      };
    }
    this.$watch(
      () => this.stateToStatepayLoadData.stateToStateBasicDetails.dob,
      (newVal: string) => {
        if (newVal) {
          const dobDate = new Date(newVal);
          const minAgeDate = new Date();
          minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
          this.isErrDobAge = dobDate > minAgeDate;
        } else {
          this.isErrDobAge = false;
        }
      },
      { immediate: true }
    );
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CPRS_STATE_APPLICATION_QUERY}`,
      })
      .then((result) => {
        this.stateApplicationData =
          result.data.cprsStateToStateApplications.data;
        this.formTitle = {
          main_title: this.stateApplicationData[0].attributes.main_title,
          sub_title: this.stateApplicationData[0].attributes.sub_title,
        };
        this.applicationNavData =
          this.stateApplicationData[0].attributes.state_application_navbar;
        this.formData = this.stateApplicationData[0].attributes.form_fields;
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index], true);
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }
  public mounted() {
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }

  public saveDraft() {
    this.$bvToast.show("example-toast");
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public nextButton() {
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    // Finalizing from the signature step must not skip earlier steps: if any is
    // incomplete (free-nav jumped past it), send the user back to it.
    if (this.formPagination === 2) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== 2) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    if (this.formPagination === 0) {
      const dob = this.stateToStatepayLoadData.stateToStateBasicDetails.dob;
      if (dob) {
        const dobDate = new Date(dob);
        const minAgeDate = new Date();
        minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
        if (dobDate > minAgeDate) {
          this.eligibilityPopupMsg =
            "You must be at least 18 years old to apply as a Certified Peer Recovery Specialist. If you have additional questions, please reach out to CPRS.TDMHSAS@tn.gov 800-560-5767.";
          this.eligibilityPopup = true;
          setTimeout(() => {
            const el = document.querySelector(".dob-age-error") as HTMLElement;
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 100);
          return;
        }
      }
    }
    this.stateToStatepayLoadData.stateToStateBasicDetails.state =
      this.stateToStatepayLoadData.stateToStateBasicDetails.state.toLocaleUpperCase();

    //signature validation
    if (this.formPagination == 2) {
      if (
        this.stateToStatepayLoadData.stateToStateSignatureSubmission.isSignature
      ) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
        return;
      }
    }

    this.$validator.validate().then(async (validate) => {
      if (validate && !this.notFilesUploadedKeyNames.length) {
        // The step completed NOW, before nextPaginationUpdate() advances it.
        const completedStep = this.formPagination;
        if (this.formPagination == 1) {
          if (
            this.stateToStatepayLoadData.stateToStateBasicDetails.email ===
            this.stateToStatepayLoadData.stateToStateCertificationDetails
              .contactPersonEmail
          ) {
            this.errorMessage =
              "Applicant email id and contact person email id must be different *";
            return;
          }
        }
        this.checkValidForm = false;
        this.isLoading = true;
        if (
          this.stateToStatepayLoadData.stateToStateBasicDetails.workEmail === ""
        ) {
          this.stateToStatepayLoadData.stateToStateBasicDetails.workEmail =
            null;
        }
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.draftSave;
        if (!this.stateToStatepayLoadData.id) {
          await stateToStateFormApi
            .StateToStateApplicationForm(
              this.stateToStatepayLoadData.fillStatus,
              this.stateToStatepayLoadData,
              this.currentRoute.split("/")[2]
            )
            .then((result: any) => {
              this.isLoading = false;
              this.formApplicationId = result.headers.location;
              localStorage.setItem(
                "stateToStateApplicationId",
                this.formApplicationId
              );
              this.stateToStatepayLoadData.id = localStorage.getItem(
                "stateToStateApplicationId"
              );
              localStorage.setItem(
                "stateToStatepayLoadData",
                JSON.stringify(this.stateToStatepayLoadData)
              );
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          const id = this.stateToStatepayLoadData.id;
          if (this.formPagination === 0) {
            await stateToStateFormApi
              .StateToStateApplicationForm(
                this.stateToStatepayLoadData.fillStatus,
                this.stateToStatepayLoadData,
                this.currentRoute.split("/")[2]
              )
              .then()
              .catch((err) => {
                this.formName = "stateToStateBasicDetails";
                this.formPagination = 0;
                this.formCompletedIndex.splice(1, 1);
                localStorage.setItem(
                  "stateToStateFilledIndex",
                  this.formCompletedIndex.toString()
                );
                this.errorMessage = err.response.data.message;
              });
          }
          await stateToStateFormApi
            .updateStateToStateForm(
              this.stateToStatepayLoadData,
              id,
              this.currentRoute.split("/")[2]
            )
            .then((data) => {
              this.isLoading = false;
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });

          localStorage.setItem(
            "stateToStatepayLoadData",
            JSON.stringify(this.stateToStatepayLoadData)
          );
          if (this.isEdit) {
            this.formPagination = 3;
          }
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        localStorage.setItem(
          "stateToStateFilledIndex",
          this.formCompletedIndex.toString()
        );
        this.currentForm = this.stateToStatepayLoadData[this.formName];
        localStorage.setItem(
          "stateToStatepayLoadData",
          JSON.stringify(this.stateToStatepayLoadData)
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  // Validate every data step's mandatory fields before Preview. vee-validate
  // only sees the on-screen step, so we render each step in turn and stop on the
  // first invalid one — landing on that tab and scrolling to the error.
  private dataStepSlugs: string[] = [
    "stateToStateBasicDetails",
    "stateToStateCertificationDetails",
    "stateToStateSignatureSubmission",
  ];

  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and scroll to the first missing required field.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.checkValidForm = true;
    this.notFilesUploadedKeyNames = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.isFileValid = !this.isFileValid;
    this.$nextTick(() => {
      this.$validator.validate().then(() => {
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  // The checks Next runs on a step that vee-validate cannot see, so a silent
  // re-derivation judges a step exactly as Next would. Side-effect free: it
  // decides completion only, never opening a popup or scrolling, because it
  // runs while the user is on their way to another tab.
  /**
   * Payload rows come back from drafts that were saved by older shapes, so a
   * key can simply be absent. A bare .toLowerCase() on one of those throws, and
   * because these checks run inside navigateTab the throw took the tab click
   * with it — the click did nothing at all, with nothing in the console to say
   * why. Everything below reads through these two instead.
   */
  private lower(value: any): string {
    return typeof value === "string" ? value.toLowerCase() : "";
  }

  private duplicateRowIdx(section: string, field: string): number[] {
    const rows = this.stateToStatepayLoadData[section];
    if (!Array.isArray(rows)) {
      return [];
    }
    const seen = new Set<string>();
    const duplicates: number[] = [];
    rows.forEach((row: any, idx: number) => {
      const value = this.lower(row && row[field]);
      if (!value) {
        return;
      }
      if (seen.has(value)) {
        duplicates.push(idx);
      } else {
        seen.add(value);
      }
    });
    return duplicates;
  }

  /**
   * A refusal always has to say something. Validation errors and the messages
   * Next uses cover most of it, but a step can be held up by something with no
   * field to flag, and then the applicant is bounced to a tab that looks
   * perfectly fine and told nothing at all.
   */
  private announceBlockedStep(step: number) {
    setTimeout(() => {
      if (
        this.errorMessage ||
        document.getElementsByClassName("is-invalid").length
      ) {
        return;
      }
      const navName = (this.applicationNavData[step] || ({} as any)).name;
      const stepName = (navName || "").trim() || "this step";
      this.errorMessage = `Please complete ${stepName} before previewing the application.`;
    }, 300);
  }

  private stepExtraChecksPass(step: number): boolean {
    const payload = this.stateToStatepayLoadData;
    if (step === 0) {
      const dob = (payload.stateToStateBasicDetails || {}).dob;
      if (!dob) {
        return true;
      }
      const minAgeDate = new Date();
      minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
      return new Date(dob) <= minAgeDate;
    }
    if (step === 1) {
      // Compared as Next compares them, so a tab Next would wave through is
      // never held back here.
      return (
        ((payload.stateToStateBasicDetails || {}).email || "") !==
        ((payload.stateToStateCertificationDetails || {}).contactPersonEmail ||
          "")
      );
    }
    if (step === this.dataStepSlugs.length - 1) {
      return !!(payload.stateToStateSignatureSubmission || {}).isSignature;
    }
    return true;
  }

  // Mark the rendered data step complete only when every required field
  // validates; unmark it when a stale/minimal-only mark is left over. Validated
  // silently, errors cleared, so nothing flashes as the user leaves the tab.
  //
  // Every data step is re-derived, not just Basic Details: a tab the applicant
  // filled in and then left by clicking another tab is finished whether or not
  // they pressed Next, and the Preview gate has to see that. Without this,
  // filling the last step and clicking Preview went nowhere — the step was not
  // marked, so the gate bounced the user straight back onto it.
  /**
   * Bring every step Preview is waiting on onto the screen and judge it exactly
   * as Next judges it. One that passes is marked and the walk moves on; the
   * first that genuinely fails is handed back so the applicant lands there with
   * its own errors showing.
   *
   * Preview is still only for an application that is actually finished — but
   * "finished" has to mean the data is there, not that the applicant happened to
   * press Next on every tab. Filling a tab and clicking Preview is a perfectly
   * ordinary thing to do, and it used to lead nowhere.
   *
   * Returns the step that blocks Preview, or -1 when nothing does.
   */
  private async settleIncompleteSteps(): Promise<number> {
    let step = this.firstIncompleteDataStep();
    if (step === -1) {
      return -1;
    }
    const landedOn = this.formPagination;
    this.isLoading = true;
    try {
      while (step !== -1) {
        if (!(await this.settleStep(step))) {
          return step;
        }
        const next = this.firstIncompleteDataStep();
        // A step that reports itself complete and still comes back as the first
        // incomplete one would spin here forever; stop and let the applicant see
        // it instead.
        if (next === step) {
          return step;
        }
        step = next;
      }
      return -1;
    } catch (error) {
      // The walk is a convenience, never a trap: if judging a step throws, put
      // the applicant back where they were rather than leaving the click dead.
      this.formPagination = landedOn;
      this.formName = this.dataStepSlugs[landedOn] || this.formName;
      return landedOn;
    } finally {
      this.isLoading = false;
    }
  }

  private async settleStep(step: number): Promise<boolean> {
    if (step !== this.formPagination) {
      // vee-validate only knows the fields currently rendered, so a step has to
      // be on screen before it can be judged.
      this.formName = this.dataStepSlugs[step];
      this.formPagination = step;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    this.prepareStepForCompletion(step);
    const valid = await this.$validator.validate();
    this.$validator.errors.clear();
    if (valid && this.stepExtraChecksPass(step)) {
      this.markStepComplete(step);
      return true;
    }
    if (valid) {
      this.explainStepBlock(step);
    }
    return false;
  }

  // What Next fills in on the applicant's behalf before it will judge a step.
  // The submission date is the whole reason Signature could never be completed
  // by filling the form: it is required, and only Next ever wrote it.
  private prepareStepForCompletion(step: number) {
    if (
      step === this.dataStepSlugs.length - 1 &&
      this.stateToStatepayLoadData.stateToStateSignatureSubmission.isSignature
    ) {
      this.stateToStatepayLoadData.stateToStateSignatureSubmission.submissionDate =
        moment().format("MM-DD-YYYY");
    }
  }

  // Say out loud why a tab is holding Preview up, in the words Next uses. The
  // conflict below is invisible to vee-validate, so without this the applicant
  // is bounced back to a tab with every field filled and nothing flagged.
  private explainStepBlock(step: number) {
    if (step === 1) {
      this.errorMessage =
        "Applicant email id and contact person email id must be different *";
      return;
    }
    if (step === this.dataStepSlugs.length - 1) {
      this.signatureInvalid = true;
    }
  }

  // Record a step as completed. The silent pass and the Preview gate both land
  // here so there is one definition of "done" and one write to storage.
  private markStepComplete(step: number) {
    if (!this.formCompletedIndex.includes(step)) {
      this.formCompletedIndex.push(step);
    }
    localStorage.setItem(
      "stateToStateFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  private async markCurrentStepIfComplete() {
    try {
      await this.deriveCurrentStepCompletion();
    } catch (error) {
      // Judging a step is a convenience. If it throws, the applicant still gets
      // to change tabs — the gate below decides what happens next.
    }
  }

  private async deriveCurrentStepCompletion() {
    const step = this.formPagination;
    if (step >= this.dataStepSlugs.length || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validate();
    this.$validator.errors.clear();
    const complete =
      valid &&
      !this.notFilesUploadedKeyNames.length &&
      this.stepExtraChecksPass(step);
    const idx = this.formCompletedIndex.indexOf(step);
    if (complete) {
      this.markStepComplete(step);
    } else if (step === 0 && idx !== -1) {
      // Only Basic Details is ever unmarked here, which is what this check was
      // written for: a draft row exists from an email alone, so a stale mark has
      // to be corrected. A later step was marked by Next, which validated the
      // whole tab with everything rendered — a silent re-check that cannot see
      // as much must not be allowed to take that away and strand the applicant
      // on a tab that looks finished.
      this.formCompletedIndex.splice(idx, 1);
      localStorage.setItem(
        "stateToStateFilledIndex",
        this.formCompletedIndex.toString()
      );
    }
  }

  // On load, re-derive step 0 completion once the tab has rendered.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markCurrentStepIfComplete();
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "stateToStateBasicDetails";
      } else if (page == 1) {
        this.formName = "stateToStateCertificationDetails";
      } else if (page == 2) {
        this.formName = "stateToStateSignatureSubmission";
      }
      this.formPagination = page;
    }
  }

  public previousButton() {
    this.notFilesUploadedKeyNames = [];
    this.isEdit = false;
    this.checkValidForm = false;
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "stateToStateBasicDetails";
      } else if (this.formPagination == 1) {
        this.formName = "stateToStateCertificationDetails";
      } else if (this.formPagination == 2) {
        this.formName = "stateToStateSignatureSubmission";
      }
    }
  }

  public onSubmit() {
    this.$validator.validate().then((validate: any) => {
      if (validate) {
        let payloadStorage: any = localStorage.getItem(
          "stateToStatepayLoadData"
        );
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.stateToStatepayLoadData = {
            ...this.stateToStatepayLoadData,
            ...payloadStorage,
          };
        }
        this.stateToStatepayLoadData.stateToStateBasicDetails.state =
          this.stateToStatepayLoadData.stateToStateBasicDetails.state.toLocaleUpperCase();
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.stateToStatepayLoadData.fillStatus = "COMPLETED";
        if (localStorage.getItem("stateToStateApplicationId")) {
          this.stateToStatepayLoadData.id = localStorage.getItem(
            "stateToStateApplicationId"
          );
        }
        const id = this.stateToStatepayLoadData.id;
        stateToStateFormApi
          .updateStateToStateForm(
            this.stateToStatepayLoadData,
            id,
            this.currentRoute.split("/")[2]
          )
          .then(() => {
            stateToStateFormApi
              .getStateToStateApplicationForm(
                id,
                this.currentRoute.split("/")[2]
              )
              .then((result: any) => {
                localStorage.removeItem("anonymousToken");
                const applicationCode = result.data.code;
                const applicationNameData = {
                  title: "Certified Peer Recovery Specialist Application",
                  SubTitle: "State to state application",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: applicationNameData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });

            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("stateToStatepayLoadData");
            localStorage.removeItem("stateToStateApplicationId");
            localStorage.removeItem("stateToStateFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state" || fieldName === "currentState") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public emptyEvent() {
    return;
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public resetFileKey(event: boolean) {
    if (event) {
      this.notFilesUploadedKeyNames = [];
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "stateToStateBasicDetails") {
      this.formPagination = 0;
    } else if (slug == "stateToStateCertificationDetails") {
      this.formPagination = 1;
    } else if (slug == "stateToStateSignatureSubmission") {
      this.stateToStatepayLoadData.stateToStateSignatureSubmission.isSignature =
        "";
      localStorage.setItem(
        "stateToStatepayLoadData",
        JSON.stringify(this.stateToStatepayLoadData)
      );
      this.formPagination = 2;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  public fieldUpdate(groupName = "", initial = false) {
    if (groupName === "dob") {
      const dob = this.stateToStatepayLoadData.stateToStateBasicDetails.dob;
      if (dob) {
        const dobDate = new Date(dob);
        const minAgeDate = new Date();
        minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
        this.isErrDobAge = dobDate > minAgeDate;
      } else {
        this.isErrDobAge = false;
      }
    }
    switch (groupName) {
      case "highSchool":
        if (
          !this.stateToStatepayLoadData.stateToStateCertificationDetails.highSchool.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("highSchoolNotListed") && !initial) {
            this.hideDiv.push("highSchoolNotListed");
            this.stateToStatepayLoadData.stateToStateCertificationDetails.highSchoolNotListed =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("highSchoolNotListed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("highSchoolNotListed"), 1);
          }
        }
        break;
      default:
        break;
    }
  }

  /**
   * The payload section the rendered step edits. The template must never index
   * the payload directly: Preview is a step with no section of its own, and a
   * draft restored from an older shape can be missing one — either way an
   * undefined section throws on every render, which blanks the form and fills
   * the console rather than showing the step.
   */
  get currentSection() {
    return this.stateToStatepayLoadData[this.formName] || {};
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Leaving a data step: mark it complete only if fully valid, so the Preview
    // gate sees a tab the applicant finished and left by clicking another tab,
    // Next or no Next. Jumping away from an unfinished tab is allowed — it just
    // does not get marked complete.
    await this.markCurrentStepIfComplete();
    // Reaching Preview requires every data step completed. If any is incomplete,
    // jump to the first one instead.
    if (index === this.dataStepSlugs.length) {
      const blocked = await this.settleIncompleteSteps();
      if (blocked !== -1) {
        this.jumpToIncompleteStep(blocked);
        this.announceBlockedStep(blocked);
        return;
      }
    }
    this.isEdit = false;
    this.checkValidForm = false;
    this.notFilesUploadedKeyNames = [];
    // Auto-save the current part as a draft before leaving it.
    this.persistDraft();
    // Preview has no payload section of its own, but the step still owns the
    // slug: the template decides which block to render from formName, so
    // pinning it to the previous step rendered that step's fields on the
    // Preview tab. Nothing may index the payload by formName without a
    // fallback — the currentSection getter is what keeps an absent section
    // from throwing.
    this.formName = slug;
    this.formPagination = index;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Persist the current payload as a draft (fillStatus stays DRAFT) without
  // validation — used when jumping between parts. The row already exists.
  // Draft saves are chained rather than fired in parallel: navigateTab does not
  // await this (the tab switches immediately), so jumping several tabs quickly
  // would otherwise leave overlapping PUTs racing, and the last response to
  // land wins regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
  }

  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave.then(() => this.saveDraftNow());
    return this.draftSave;
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
    const app = this.stateToStatepayLoadData.stateToStateBasicDetails;
    if (!this.stateToStatepayLoadData.id) {
      if (!utils.canSaveDraftRemotely(app.email)) {
        return;
      }
      try {
        const result: any =
          await stateToStateFormApi.StateToStateApplicationForm(
            this.stateToStatepayLoadData.fillStatus,
            this.stateToStatepayLoadData,
            this.currentRoute.split("/")[2]
          );
        this.formApplicationId = result.headers.location;
        localStorage.setItem(
          "stateToStateApplicationId",
          this.formApplicationId
        );
        this.stateToStatepayLoadData.id = this.formApplicationId;
        localStorage.setItem(
          "stateToStatepayLoadData",
          JSON.stringify(this.stateToStatepayLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await stateToStateFormApi.updateStateToStateForm(
        this.stateToStatepayLoadData,
        this.stateToStatepayLoadData.id,
        this.currentRoute.split("/")[2]
      );
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "stateToStatepayLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
    // The header was hidden with "remove-container" when this form opened;
    // put it back however the form is left (Back button, menu, route change).
    const headerEl = document.getElementById("header");
    if (headerEl) {
      headerEl.classList.add("active");
      headerEl.classList.remove("remove-container");
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public closedEligibilityPopup(event: any) {
    this.eligibilityPopup = false;
    if (event) {
      this.$router.push("/user-dashboard/home");
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }
  public goBack() {
    this.$router.push({
      path: `/application`,
      query: {
        form: "state-to-state",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
}
